var modules_84b8c723 = {"text":"WithIcon_module_text__b5ed7afa"};
import "../../../../assets/esm/components/OfferCard/components/WithIcon/WithIcon~C0cUFlc8.css";

export { modules_84b8c723 as default };
//# sourceMappingURL=WithIcon.module.scss.js.map
